import { WorkspaceTab, WorkspaceTabsActionTypes } from './types';

export type WorkspaceTabsAction =
  | { type: WorkspaceTabsActionTypes.OPEN_TAB; payload: WorkspaceTab }
  | { type: WorkspaceTabsActionTypes.ACTIVATE_TAB; payload: string }
  | { type: WorkspaceTabsActionTypes.CLOSE_TAB; payload: string }
  | { type: WorkspaceTabsActionTypes.UPDATE_TAB_TITLE; payload: { key: string; title: string } }
  | {
      type: WorkspaceTabsActionTypes.UPDATE_TAB_UI_STATE;
      payload: { key: string; uiState: Record<string, unknown> };
    }
  | { type: WorkspaceTabsActionTypes.CLEAR_TABS };

export const openWorkspaceTab = (tab: WorkspaceTab): WorkspaceTabsAction => ({
  type: WorkspaceTabsActionTypes.OPEN_TAB,
  payload: tab,
});

export const activateWorkspaceTab = (key: string): WorkspaceTabsAction => ({
  type: WorkspaceTabsActionTypes.ACTIVATE_TAB,
  payload: key,
});

export const closeWorkspaceTab = (key: string): WorkspaceTabsAction => ({
  type: WorkspaceTabsActionTypes.CLOSE_TAB,
  payload: key,
});

export const updateWorkspaceTabTitle = (key: string, title: string): WorkspaceTabsAction => ({
  type: WorkspaceTabsActionTypes.UPDATE_TAB_TITLE,
  payload: { key, title },
});

export const updateWorkspaceTabUiState = (
  key: string,
  uiState: Record<string, unknown>
): WorkspaceTabsAction => ({
  type: WorkspaceTabsActionTypes.UPDATE_TAB_UI_STATE,
  payload: { key, uiState },
});

export const clearWorkspaceTabs = (): WorkspaceTabsAction => ({
  type: WorkspaceTabsActionTypes.CLEAR_TABS,
});
